export const enum TypeForm {
  INFO,
  CV,
}
